import type { TagFromTree, ViewTag } from "../models/TrendingModelsV2";
import { getRandomColor } from "./tagColors";

export const createViewTagFromTree = (tag: TagFromTree): ViewTag => ({
	TagId: tag.TagId,
	TagName: tag.TagName,
	TagType: tag.TagTypeCode === "D" ? "D" : "A",
	Alias: tag.Alias || tag.TagName,
	Color: tag.Color || getRandomColor(),
	MinScale: tag.MinScale ?? 0,
	MaxScale: tag.MaxScale ?? 100,
	IsAutoScale: true,
	IsVisible: true,
	Unit: tag.Unit || "",
});
